"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileMenu = void 0;
/**
 * Behaviour-only wrapper around the mobile navigation menu.
 *
 * The markup (a <details>/<summary> pair) is injected at build time from
 * src/components/templates/navigation-bar.html, and it already opens, closes
 * and announces its state without any JavaScript — that is why it is a
 * <details> and not a button: the navigation keeps working if this bundle
 * never loads.
 *
 * What the element cannot do on its own, and this class adds:
 *   - Escape closes it (and hands focus back to the summary, so keyboard users
 *     are not dropped at the top of the document);
 *   - a click anywhere outside closes it, which is what every other dropdown on
 *     the web does and what a visitor expects;
 *   - activating a link closes it: the section links are same-page anchors on
 *     the landing page, so no navigation happens and the panel would otherwise
 *     stay open on top of the section it just scrolled to;
 *   - growing past the md breakpoint closes it: the inline link row takes over
 *     there and the panel is hidden by CSS anyway, so leaving it open would
 *     mean it silently reappears on the way back to a narrow viewport.
 */
class MobileMenu {
    element;
    summary;
    constructor(element) {
        this.element = element;
        this.summary = element.querySelector('summary');
        this.setupEventListeners();
    }
    close() {
        this.element.open = false;
    }
    setupEventListeners() {
        document.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape' || !this.element.open)
                return;
            this.close();
            this.summary?.focus();
        });
        document.addEventListener('click', (event) => {
            if (!this.element.open)
                return;
            const target = event.target;
            // A click on the summary is the element's own toggle — closing here too
            // would immediately undo the open it just performed.
            if (!this.element.contains(target)) {
                this.close();
                return;
            }
            if (target.closest?.('a')) {
                this.close();
            }
        });
        // Matches the md breakpoint the panel is hidden at (Tailwind's default md
        // is 768px, and the query is min-width so it fires exactly at the handover).
        const desktop = window.matchMedia('(min-width: 768px)');
        desktop.addEventListener('change', (event) => {
            if (event.matches)
                this.close();
        });
    }
}
exports.MobileMenu = MobileMenu;
